import { LOCALE_EN, LOCALE_RU } from '../constant';
import { PROPERTIES_URL, getFetchRequest } from '../store/requests';
import {
    buildCsv,
    downloadCsvFile,
    getLocalizedName,
} from './csvExportUtils';
import { errorCallback, makeUrl } from '../util';

const PROPERTIES_EXPORT_QUERY = '?withDeleted=true&withStatus=true';

const PROPERTY_CSV_HEADERS = [
    'propertyId',
    'propertyName',
    'categoryName',
    'propertyType',
    'isVitamin',
    'isWaterSoluble',
    'description',
    'userDisplayGroup',
    'numberUnits',
    'selectValues',
    'isDeleted',
    'dateCreated',
    'nameRu',
    'nameEn',
    'valueCode',
    'valueNameRu',
    'valueNameEn',
];

const formatBool = (value) => (value === true ? 'true' : value === false ? 'false' : '');

const groupValueNamesByCode = (valueNames) => {
    const grouped = {};
    (valueNames || []).forEach((item) => {
        const code = item.valueCode || '';
        if (!grouped[code]) {
            grouped[code] = [];
        }
        grouped[code].push(item);
    });
    return grouped;
};

const mapPropertyBaseFields = (property) => ([
    property.id || '',
    property.propertyName || '',
    property.categoryName || '',
    property.propertyType || '',
    formatBool(property.isVitamin),
    formatBool(property.isWaterSoluble),
    property.description || '',
    property.userDisplayGroup || '',
    property.numberUnits || '',
    property.selectValues || '',
    formatBool(property.isDeleted),
    property.dateCreated || '',
    getLocalizedName(property.names, LOCALE_RU),
    getLocalizedName(property.names, LOCALE_EN),
]);

const mapPropertyValueRow = (property, valueCode, valueNamesForCode) => [
    ...mapPropertyBaseFields(property),
    valueCode,
    getLocalizedName(valueNamesForCode, LOCALE_RU),
    getLocalizedName(valueNamesForCode, LOCALE_EN),
];

export const exportPropertiesToCsv = (onComplete) => {
    getFetchRequest(
        makeUrl([PROPERTIES_URL, PROPERTIES_EXPORT_QUERY]),
        (properties) => {
            const rows = [];
            (properties || []).forEach((property) => {
                const valueNamesByCode = groupValueNamesByCode(property.valueNames);
                const valueCodes = Object.keys(valueNamesByCode);
                if (valueCodes.length === 0) {
                    rows.push([
                        ...mapPropertyBaseFields(property),
                        '', '', '',
                    ]);
                    return;
                }
                valueCodes.forEach((valueCode) => {
                    rows.push(mapPropertyValueRow(property, valueCode, valueNamesByCode[valueCode]));
                });
            });
            const csv = buildCsv(PROPERTY_CSV_HEADERS, rows);
            downloadCsvFile('properties.csv', csv);
            onComplete?.();
        },
        (err) => {
            errorCallback(err);
            onComplete?.();
        },
    );
};
